import { parsePhoneForInput } from "@/components/crm/contact/contact-edit-form"

/** Extensions are shown as raw digits; longer values format as a US phone number. */
const EXTENSION_DISPLAY_MAX_LEN = 6

export function transferDialToDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 10)
}

export function formatTransferDialInput(digits: string): string {
  if (digits.length === 0) return ""
  if (digits.length <= EXTENSION_DISPLAY_MAX_LEN) return digits
  return parsePhoneForInput(digits)
}
